const traceable = {
    title: "Software Engineer",
    company: "Traceable",
    period: "July 2024 - Present",
    description: "Part of the platform team. Building scalable and reliable systems to process and analyze large amounts of data.",
  };
  
  export default traceable;
  